import { HasAddressRecord } from "@/core/repos/table.repo"
export interface TollAreaModel extends HasAddressRecord {
    name: string,
    code: string,
    provinceId: string,
    districtId: string,
    wardId: string,
    managerId: string,
    managerName: string,
    readerId: string,
    readerName: string,
    gps: string,
    waterFactoryId: string,
    exportDate: number,
    tollCollectorId: string,
    tollCollectorName: string,
    id: string,
    createdAt: string,
    updatedAt: string,
    createdBy: string,
    updatedBy: string,
    status: string
}

export class TollAreaModelFactory {
    static getEmpty(): TollAreaModel {
        return {
            name: "",
            code: "",
            provinceId: "",
            districtId: "",
            wardId: "",
            provinceName: "",
            districtName: "",
            wardName: "",
            managerId: "",
            managerName: "",
            readerId: "",
            readerName: "",
            gps: "",
            waterFactoryId: "",
            exportDate: 0,
            tollCollectorId: "",
            tollCollectorName: "",
            id: "",
            createdAt: "",
            updatedAt: "",
            createdBy: "",
            updatedBy: "",
            status: ""
        }
    }
}